<template>
  <mdb-container>
    <div class="text-left">
      <mdb-btn :disabled="executing" @click="doCancel" rounded size="sm">
        <mdb-icon icon="arrow-left"/>
        Back to Main
      </mdb-btn>
    </div>

    <mdb-card :class="animationClass + ' text-left'" v-for="(q,i) in questionData" v-if="i==currentQuestion" :key="i">
      <mdb-card-header class="text-white">
        <h5>{{i+1}}. {{q.question}}
        <div class="toolbar-buttons">
          <mdb-btn icon="arrow-left" size="sm" rounded @click="prev"/>
          <mdb-btn icon="arrow-right" size="sm" rounded @click="next"/>
        </div>
        </h5>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-tbl striped>
          <mdb-tbl-body>
            <tr class="answer-box" v-for="(a,j) in q.answers">
              <td style="width:20%">
                <avatar :avatar="a.avatar"/>
                <mdb-badge color="warning" v-if="a.rsvpStatus=='Waiting'">On Waitlist</mdb-badge>
                <mdb-badge color="danger" v-if="a.rsvpStatus=='Not Going'">Not Going</mdb-badge>
              </td>
              <td><p><mdb-badge color="primary">{{a.name}}</mdb-badge></p>
                {{a.answer}}</td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-card-body>
    </mdb-card>


  </mdb-container>

</template>

<script>
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbChip,
  mdbContainer,
  mdbIcon,
  mdbTbl,
  mdbTblBody
} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import Avatar from "../common/Avatar";

export default {
    name: 'Event-Question-Viewer',
    components: {
      mdbBtn,
      mdbBadge,
      mdbCard,
      mdbCardBody,
      mdbCardHeader,
      mdbContainer,
      mdbChip,
      mdbTblBody,
      mdbTbl,
      mdbIcon,
      Avatar
    },
    props: {
      event: {
        type: Object,
        default: []
      }
    },
    computed: {
      userDetails() {
        return this.$store.state.userDetails
      },
      group() {
        return this.$store.state.currentGroup
      },
      executing() {
        return this.$store.state.executing
      }
    },

    data() {
      return {
        questionData: [],
        currentQuestion: 0,
        animationClass: "animated fadeInRight"
      }
    },
    mounted() {
      this.$store.dispatch("setExecuting", true);
      api.get("/event/questionResponses/" + this.event.eventId).then(
        (results) => {
          this.questionData = results.data;
        },
        (error) => {
          this.$notify.error({message: "Could not load responses. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      doCancel() {
        this.$emit("cancel")
      },
      prev() {
        this.animationClass = "animated fadeInLeft"
        let i = this.currentQuestion - 1
        if (i<0) i=this.questionData.length - 1
        this.currentQuestion = i
      },
      next() {
        this.animationClass = "animated fadeInRight"
        let i = this.currentQuestion + 1
        if (i> this.questionData.length - 1) i = 0
        this.currentQuestion = i
      }
    }
  }
  ;
</script>
<style scoped>
  .toolbar-buttons {
    float: right;
  }
</style>
